import Vue from 'vue'
import Vuex from 'vuex'
import Categories from './categories'
import Locations from './locations'
import Industries from './industries'
import DateTimeIntervals from './dateTimeIntervals'
import Appointments from './appointments'

Vue.use(Vuex)

const state = () => ({
  initialized: false,
  errors: []
})

const getters = {}

const mutations = {
  setInitialized (state, payload) {
    state.initialized = payload
  },
  setErrors (state, payload) {
    state.errors.push(payload)
  }
}

const actions = {
  init ({ dispatch, commit }) {
    Promise.all([
      dispatch('categories/get'),
      dispatch('locations/get'),
      dispatch('industries/get'),
      dispatch('appointments/get')
    ]).then(() => {
      commit('setInitialized', true)
    })
  },
  filter ({ dispatch, commit }) {
    commit('appointments/resetCurrentPage')
    Promise.all([
      dispatch('appointments/get'),
    ])
  },
  loadMore ({ commit, dispatch }) {
    commit('appointments/increaseCurrentPage')
    Promise.all([
      dispatch('appointments/get')
    ])
  }
}

const modules = {
  categories: Categories,
  locations: Locations,
  industries: Industries,
  dateTimeIntervals: DateTimeIntervals,
  appointments: Appointments
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules
})
